import { lazy } from "react";

export const LandingPage = lazy(() => import("./LandingPage"));
export const CreatorsLandingPage = lazy(() => import("./CreatorsLandingPage"));
